<!-- Going for a distinct mobile layout for enabling a different view strategy -->
<ng-container *ngIf="isMobileEnabled;then mobile else web">

</ng-container>


<ng-template #web>
    <div class="core-container"
         *ngIf="!hasResolutionLimit; else screenLimitMessage">
        <div class="supergraphic">
        </div>
        <app-toolbar class="toolbar"
                     *ngIf="showToolbar"
                     (logoutFired)="onLogout()"
                     (languageChange)="onLanguageChange($event)"
                     (roleChange)="onRoleChange($event)"
                     (selectedPlantsChange)="onSelectedPlant($event)"
                     [availableRoles]="availableRoles"
                     [currentUser]="currentUser"
                     [currentLanguage]="currentLanguage"
                     [languages]="languages"
                     [hasPlantDropdown]="hasPlantDropdown"
                     [allPlants]="((allPlants$ | async)?.items) || []"
                     [selectedRoleId]="selectedRoleId"
                     [selectedPlants]="selectedPlants"
                     [hasSidebar]="hasSidebar"
                     [hideShadow]="hideHeaderShadow"
                     [isRoleSwitchInProgress]="isRoleSwitchInProgress"
                     [isMobile]="isMobileEnabled">
        </app-toolbar>
        <app-sidebar class="sidebar" *ngIf="hasSidebar"
                     [currentUser]="currentUser"
                     [serviceOperations]="serviceOperations">
        </app-sidebar>
        <main [class.mobile]="isMobileEnabled">
            <router-outlet></router-outlet>
        </main>
    </div>
</ng-template>


<ng-template #mobile>
    <div class="mobile-container"
         [class.onMobile]="isMobileEnabled"
         *ngIf="!hasResolutionLimit; else screenLimitMessage">
        <div class="supergraphic">
        </div>
        <app-toolbar class="toolbar"
                     *ngIf="showToolbar"
                     (logoutFired)="onLogout()"
                     (languageChange)="onLanguageChange($event)"
                     (roleChange)="onRoleChange($event)"
                     (selectedPlantsChange)="onSelectedPlant($event)"
                     [availableRoles]="availableRoles"
                     [currentUser]="currentUser"
                     [currentLanguage]="currentLanguage"
                     [languages]="languages"
                     [hasPlantDropdown]="hasPlantDropdown"
                     [allPlants]="((allPlants$ | async)?.items) || []"
                     [selectedRoleId]="selectedRoleId"
                     [selectedPlants]="selectedPlants"
                     [hasSidebar]="hasSidebar"
                     [hideShadow]="hideHeaderShadow"
                     [isRoleSwitchInProgress]="isRoleSwitchInProgress"
                     [isMobile]="isMobileEnabled">
        </app-toolbar>
        <app-sidebar class="sidebar" *ngIf="hasSidebar"
                     [currentUser]="currentUser"
                     [serviceOperations]="serviceOperations">
        </app-sidebar>
        <main>
            <router-outlet></router-outlet>
        </main>
    </div>
</ng-template>


<ng-template #screenLimitMessage>
    <h5 class="screen-limit-msg">The window size is too small. Please resize it or zoom out to see the page's
        content.</h5>
</ng-template>

<app-logout-modal
    [title]="'core.inactivity.logoutModal.title' | translate"
    [infoMessage]="'core.inactivity.logoutModal.infoMessage' | translate"
    [timer]="badgeLogoutCountdownSeconds"
    [autoZIndex]="true"
    [baseZIndex]="3000"
    [redirectToHome]="false"
    [externalLogoutHandling]="true"
    (continue)="onContinueAfterInactivityWarning()"
    (timeout)="onLogout()">
</app-logout-modal>
